export enum Nature {
    NATURAL = 'Nature',
    COMPANY = 'Legal',
}
